export const formatRuleName = (rule: string): string => {
  const components = rule.split(".");
  if (components.slice(-1)[0] === "") {
    components.pop();
  }
  return rule.split(".").slice(-1)[0];
};

export const formatScaRuleName = (rule: { [key: string]: any }): string => {
  const ruleMetadata: Record<string, any> = rule.metadata;
  const cwes = ruleMetadata.cwe;

  let vuln_package = rule["r2c-internal-project-depends-on"];
  if (vuln_package["depends-on-either"] !== undefined) {
    vuln_package = vuln_package["depends-on-either"][0];
  }

  const packageName = vuln_package["package"];

  if (!cwes) {
    return packageName;
  }

  const firstCwe = cwes[0];
  const firstCweName = firstCwe.replace(/^CWE-\d+?: ?/, "");
  const firstCweShortName = firstCwe.match(/'(.+?)'/);

  if (firstCweShortName) {
    return `${packageName}: ${firstCweShortName[1]}`;
  }

  return `${packageName}: ${firstCweName}`;
};
